import React, { Component } from 'react';

// https://github.com/MoOx/react-svg-inline/blob/894f69bc6e004e667afaa61c2a3c27f5dbd59580/src/index.js#L7
const cleanups = {
  // Remove generic useless stuff
  title: /<title>.*<\/title>/gi,
  desc: /<desc>.*<\/desc>/gi,
  comment: /<!--.*-->/gi,
  defs: /<defs>.*<\/defs>/gi,

  // Remove hardcoded dimensions
  width: / +width="\d+(\.\d+)?(px)?"/gi,
  height: / +height="\d+(\.\d+)?(px)?"/gi,

  // Remove fill and stroke
  fill: / +fill="(none|#[0-9a-f]+)"/gi,
  stroke: / +stroke="(none|#[0-9a-f]+)"/gi,

  // Sketch.app stuff
  sketchMSShapeGroup: / +sketch:type="MSShapeGroup"/gi,
  sketchMSPage: / +sketch:type="MSPage"/gi,
  sketchMSLayerGroup: / +sketch:type="MSLayerGroup"/gi,
};

// @todo Add memoization logic.
class InlineSvg extends Component {
  clean(svg) {
    return Object.keys(cleanups)
      .reduce((cleaned, property) => cleaned.replace(cleanups[property], ''), svg)
      .trim();
  }

  render() {
    return <span className={this.props.className} dangerouslySetInnerHTML={{
      __html: this.clean(this.props.svg).replace(
        '/<svg/',
        `<svg class="${this.props.className}" ${this.props.fill ? `fill="${this.props.fill}"` : ''} ${this.props.stroke ? `stroke="${this.props.stroke}"` : ''}`
      )
    }} />
  }
}

InlineSvg.defaultProps = {
  key: null,
  svg: '',
  fill: null,
  stroke: null,
};

export default InlineSvg;



// WEBPACK FOOTER //
// ./src/InlineSvg.js